import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#C8102E',
      dark: '#9B0020',
      light: '#E8314F',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#111111',
      dark: '#000000',
      light: '#2A2A2A',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F5F5F5',
    },
    text: {
      primary: '#111111',
      secondary: '#444444',
    },
    grey: {
      50: '#FAFAFA',
      100: '#F0F0F0',
      200: '#E0E0E0',
      800: '#222222',
      900: '#111111',
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    h1: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 700,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
    },
    h2: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 600,
      letterSpacing: '0.03em',
      textTransform: 'uppercase',
    },
    h3: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
    h4: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 500,
      letterSpacing: '0.02em',
    },
    h5: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 500,
    },
    button: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 500,
      letterSpacing: '0.08em',
    },
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '12px 32px',
          fontSize: '0.9rem',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
        },
        containedPrimary: {
          background: '#C8102E',
          '&:hover': {
            background: '#9B0020',
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 20px rgba(200,16,46,0.35)',
          },
          transition: 'all 0.2s ease',
        },
        containedSecondary: {
          background: '#111111',
          '&:hover': {
            background: '#000000',
            transform: 'translateY(-1px)',
          },
          transition: 'all 0.2s ease',
        },
        outlined: {
          borderRadius: 0,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#E0E0E0',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          transition: 'box-shadow 0.3s ease, transform 0.3s ease',
          '&:hover': {
            boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
            transform: 'translateY(-4px)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
  },
});

export default theme;
